package br.com.htms.inspeccaocampo.platform

import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.coroutines.await
import kotlinx.coroutines.delay
import org.w3c.dom.HTMLFormElement
import org.w3c.dom.HTMLInputElement
import kotlin.js.Promise

/**
 * A tela é desenhada em canvas, então o navegador não enxerga os campos de login.
 * Chrome/Edge: Credential Management API (PasswordCredential).
 * Firefox/Safari: formulário HTML real e invisível, que o gerenciador de senhas reconhece.
 */
actual object CredenciaisNavegador {
    private var form: HTMLFormElement? = null

    private fun temApiCredenciais(): Boolean = runCatching {
        js("typeof window.PasswordCredential === 'function' && !!navigator.credentials && typeof navigator.credentials.store === 'function'") as Boolean
    }.getOrDefault(false)

    private fun campo(id: String) = document.getElementById(id) as? HTMLInputElement

    private fun formulario(): HTMLFormElement {
        form?.let { if (document.body?.contains(it) == true) return it }
        val f = document.createElement("form") as HTMLFormElement
        f.id = "icd-login-form"
        f.method = "post"
        f.setAttribute("autocomplete", "on")
        f.setAttribute("aria-hidden", "true")
        f.setAttribute(
            "style",
            "position:fixed;left:0;top:0;width:1px;height:1px;opacity:0.01;overflow:hidden;z-index:-1;pointer-events:none;"
        )
        val u = document.createElement("input") as HTMLInputElement
        u.type = "text"
        u.name = "username"
        u.id = "icd-login-usuario"
        u.tabIndex = -1
        u.setAttribute("autocomplete", "username")
        val s = document.createElement("input") as HTMLInputElement
        s.type = "password"
        s.name = "password"
        s.id = "icd-login-senha"
        s.tabIndex = -1
        s.setAttribute("autocomplete", "current-password")
        f.appendChild(u)
        f.appendChild(s)
        f.addEventListener("submit", { e -> e.preventDefault() })
        document.body?.appendChild(f)
        form = f
        return f
    }

    actual suspend fun obter(): Pair<String, String>? {
        if (temApiCredenciais()) {
            val cred: dynamic = runCatching {
                val opcoes: dynamic = js("({ password: true, mediation: 'optional' })")
                (window.navigator.asDynamic().credentials.get(opcoes) as Promise<dynamic>).await()
            }.getOrNull()
            val id = (cred?.id as? String).orEmpty()
            val senha = (cred?.password as? String).orEmpty()
            return if (id.isNotBlank() && senha.isNotEmpty()) id to senha else null
        }
        return runCatching {
            formulario()
            delay(800)
            val id = campo("icd-login-usuario")?.value.orEmpty()
            val senha = campo("icd-login-senha")?.value.orEmpty()
            if (id.isNotBlank() && senha.isNotEmpty()) id to senha else null
        }.getOrNull()
    }

    actual fun lerLocal(chave: String): String? = runCatching { kotlinx.browser.localStorage.getItem(chave) }.getOrNull()

    actual fun gravarLocal(chave: String, valor: String?) {
        runCatching {
            if (valor == null) kotlinx.browser.localStorage.removeItem(chave)
            else kotlinx.browser.localStorage.setItem(chave, valor)
        }
    }

    actual fun salvar(usuario: String, senha: String) {
        if (usuario.isBlank() || senha.isEmpty()) return
        if (temApiCredenciais()) {
            runCatching {
                val dados: dynamic = js("({})")
                dados.id = usuario
                dados.password = senha
                dados.name = usuario
                val ctor: dynamic = js("window.PasswordCredential")
                val cred: dynamic = js("Reflect").construct(ctor, arrayOf(dados))
                window.navigator.asDynamic().credentials.store(cred)
            }
            return
        }
        runCatching {
            val f = formulario()
            campo("icd-login-usuario")?.value = usuario
            campo("icd-login-senha")?.value = senha
            f.asDynamic().requestSubmit()
            window.setTimeout({
                f.remove()
                form = null
            }, 300)
        }
    }
}
